import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';
import { Box, Card, CardContent, Divider, Grid, Stack, Typography, } from '@mui/material';
import ItemHeadline from '../item/card/ItemHeadline';
import ItemInfo from '../item/card/ItemInfo';
import ItemInstructors from '../item/card/ItemInstructors';
import ItemCallToAction from '../item/card/enrollPrice/CallToAction';
import AssetImage from '../common/asset/AssetImage';
import AssetVideoPlayer from '../common/asset/AssetVideoPlayer';
const StyledDivider = styled(Divider)(() => ({
    borderBottomWidth: 1,
}));
const MeetingSummary = ({ meeting, buttonLabel, action, instructorAction, 
// action,
settings, }) => {
    const getSetting = (name) => {
        if (settings && settings[name] !== undefined) {
            return settings[name];
        }
        return MeetingSummary.defaultProps.settings[name];
    };
    const showTitle = getSetting('showTitle');
    const showVideo = getSetting('showVideo');
    const showInfo = getSetting('showInfo');
    const showHeadline = getSetting('showHeadline');
    const showDescription = getSetting('showDescription');
    const showInstructor = getSetting('showInstructor');
    const showActionButton = getSetting('showActionButton');
    const showMedia = showVideo && (meeting.promoVideo || meeting.image);
    return (_jsx(Card, { sx: {
            boxShadow: '0 0 18px 0 rgba(9, 32, 46, 0.2)',
            minWidth: '400px',
        }, children: _jsx(CardContent, { children: _jsxs(Grid, { container: true, spacing: 2.5, children: [_jsx(Grid, { item: true, sm: 12, md: 7, order: { xs: 2, md: 0 }, children: _jsxs(Stack, { spacing: 1, divider: _jsx(StyledDivider, {}), flexGrow: 1, children: [showTitle && meeting?.name && (_jsx(Typography, { component: "div", variant: "h3", fontWeight: "fontWeightBold", sx: { marginY: 'auto !important', mb: 3.5 }, className: "landingpage-section-header", children: meeting?.name })), showInfo && _jsx(ItemInfo, { item: meeting }), ((showHeadline && meeting.headline) || (showDescription && meeting.description)) && (_jsx(ItemHeadline, { headline: meeting.headline, description: showDescription && meeting.description, size: "medium", isShowMore: showDescription })), showInstructor && meeting.instructors.length && (_jsx(ItemInstructors, { showAvatar: true, size: "large", instructors: meeting.instructors, instructorAction: instructorAction })), _jsx(ItemCallToAction, { showButton: showActionButton, price: meeting.price, sellPrice: meeting.sellPrice, action: action, buttonLabel: buttonLabel, isFlexGrow: true })] }) }), showMedia && (_jsx(Grid, { item: true, sm: 12, md: 5, order: { xs: 1, md: 0 }, children: _jsx(Box, { sx: { width: 'auto' }, children: meeting.promoVideo ? (_jsx(AssetVideoPlayer, { aspectRatio: "4:3", asset: meeting.promoVideo, assetPoster: meeting.image, seekPosition: undefined, seekTrigger: undefined, onProgress: () => { }, onEnd: () => { }, onPause: () => { }, onDuration: () => { }, handleNextPrevious: () => { }, disableSeekAhead: false })) : (_jsx(AssetImage, { asset: meeting.image, size: "thumb400w", customStyle: { width: '100%', objectFit: 'cover' } })) }) }))] }) }) }));
};
MeetingSummary.defaultProps = {
    settings: {
        showTitle: true,
        showVideo: true,
        showInfo: true,
        showHeadline: true,
        showDescription: true,
        showInstructor: true,
        showEnrollButton: true,
        showActionButton: true,
    },
};
export default observer(MeetingSummary);
//# sourceMappingURL=MeetingSummary.js.map